<div siqGrid fx-direction="column" class="select-container">
  @if(dropdownInputLabel) {
    <app-siq-dropdown-input [label]="dropdownInputLabel" [value]="dropdownInputValue" [placeholder]="dropdownInputPlaceholder" [description]="description" class="px-12"/>
  }
  <div [class.position-relative]="dropdownInputLabel" class="dropdown-container">
    @if(showDropdownBody) {
      <div siqGrid fx-direction="column" class="dropdown-body background-primary br-8 mt-24" [class.input-dropdown]="dropdownInputLabel" #dropdownBody>
        <div [class]="paddingClass">
          @for(value of dropdownValues; track $index; let i = $index) {
            <div siqGrid fx-direction="row" fx-layout-align="center center"
              class="dropdown-item cursor-pointer" 
              [id]="(getDropdownItemId(i))"
              [class.mb-12]="i < dropdownValues.length - 1"
              [class.selected-item]="isSelected(value)"
              (click)="selectValue(value)">
              <span [class]="dropdownOptionTextClasses(i)">{{ dropdownOptions[i] }}</span>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>